import useTranslation from "next-translate/useTranslation";
import { useCallback, useContext, useEffect, useState } from "react";
import { CreateContext } from "../../../contexts/CreateContext";
import { ProgressBar } from "../../ProgressBar/ProgressBar";
import { Spinner } from "../../Spinner/Spinner";
import { UploadProgress } from "../../UploadDropzone/uploadManager";

export const UploadProgressBar = () => {
    const { uploadManager, galleryItems } = useContext(CreateContext);
    const [ totalProgress, setTotalProgress ] = useState<UploadProgress>(uploadManager.getTotalProgress());
    const { t } = useTranslation('create');

    const onTotalProgress = (progress: UploadProgress) => {
        setTotalProgress({
             ...progress
        });
    };

    useEffect(() => {
        if (uploadManager) {
            uploadManager.UploadsTotalProgress.on(onTotalProgress);
        }

        return () => {
            uploadManager.UploadsTotalProgress.off(onTotalProgress);
        }
    }, [uploadManager]);

    const hasErrors = galleryItems.filter(u => uploadManager.getUpload(u.id).status === 'error').length > 0;
    const text = totalProgress.progress === 100 ? <span>{hasErrors ? t('uploadProgress.error') : t('uploadProgress.complete')}</span> : <span>{t('uploadProgress.uploading')} {(totalProgress.progress).toFixed(0)}%</span>;


    return (
        <>
        <ProgressBar className="my-6 h-[32px] p-0" progress={totalProgress.progress}>
            <div className="flex items-center justify-center gap-x-2">
            {totalProgress.progress != 100 && <Spinner />}
            {text}
            </div>
        </ProgressBar>
            {hasErrors &&
                <div className="flex flex-col items-center justify-center space-y-4">
                    <button onClick={() => uploadManager.retryAll()} className="btn btn-secondary">{t('uploadProgress.retry')}</button>
                    <span className="text-secondary text-base text-center">{t('uploadProgress.retryReason')}</span>
                </div>
        }
        </>
    )
}